import React from "react";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  footer: {
    marginBottom: theme.spacing(5),
  }
}));

export default function Footer() {

  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <Typography variant="body2" color="secondary" align="center">
        {'Copyright © '}
        <Link color="inherit" href="https://borisng.com/">
          Boris Ng
        </Link>{' '}
        {new Date().getFullYear()}
        {'- All rights reserved'}
      </Typography>
    </footer>
  );
}
